import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import classnames from 'classnames';
import LoadingPlaceholder from '../../../components/LoadingPlaceholder';
import ContactGroup from '../ContactGroup';
import { listingPropTypes } from '../../../utils/commonPropTypes';
import { useFeatureFlags } from '../../../context/hooks/useFeatureFlags';
import { isInViewport } from '../../../utils/scrollHelper';
import './styles.css';

const StickyContact = (props) => {
  const [isHidden, setIsHidden] = useState(false);

  const { featureFlagBDPNewDesign } = useFeatureFlags();

  useEffect(() => {
    if (!featureFlagBDPNewDesign) {
      return;
    }
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleScroll = () => {
    const contactForm = document.querySelector('.email-lead-form');
    if (applyStackedGalleryStyles) {
      setIsHidden(false);
    } else {
      isInViewport(contactForm) ? setIsHidden(true) : setIsHidden(false);
    }
  };

  const renderLoading = () => {
    return <LoadingPlaceholder type="text" />;
  };

  const renderContact = () => {
    return <ContactGroup {...props} />;
  };

  const isManufacturer = get(props, 'isManufacturer', false);
  const { isLoading, isModalCarouselShown, breakpoint } = props;
  const applyStackedGalleryStyles = featureFlagBDPNewDesign && breakpoint === 'mobile' && isModalCarouselShown;
  return (
    <div className={classnames('sticky-contact', {hidden: isHidden} , { 'sticky-contact-manufacturer': isManufacturer }, { 'stackedGallery': applyStackedGalleryStyles } )}>
      {isLoading
        ? renderLoading()
        : renderContact()}
    </div>
  );
};

StickyContact.defaultProps = {
  isLoading: false,
  isManufacturer: false,
};

StickyContact.propTypes = {
  isLoading: PropTypes.bool,
  listing: listingPropTypes,
  isManufacturer: PropTypes.bool,
  isModalCarouselShown: PropTypes.bool,
  breakpoint: PropTypes.string
};

export default StickyContact;
